import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";

import React from "react";
import clientComponent from "../../../config/clientComponents";
import { slugify } from "../../../utils/slugifyString";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const GenericFilter = ({
  filters,
  filterName,
  filtersState,
  setFiltersState,
  setSelectedInstitution,
  index,
  filtersKeys,
}) => {
  const { t, i18n } = useTranslation();
  let itemDiv = "";
  let filterDiv = "";

  //----------- Styling filter layout depending on the filter (to change)

  let typeFilters = [];
  const [isOpen, setIsOpen] = useState(true);
  const [isDisplayed, setIsDisplayed] = useState(false);
  const filterSearchRef = useRef(null);
  const [filtersSearch, setFiltersSearch] = useState("");

  // useEffect(() => {
  //   if (
  //     Object.keys(filtersState).length > 0 &&
  //     index > 0 &&
  //     !filtersState[filtersKeys[0]]?.includes(filters[filterName]["slug"])
  //   ) {
  //     setFiltersState((prev) => ({ ...prev, [filtersKeys[index]]: [] }));
  //     setIsDisplayed(false);
  //   } else if (
  //     Object.keys(filtersState).length > 0 &&
  //     index > 0 &&
  //     filtersState[filtersKeys[0]]?.includes(filters[filterName]["slug"])
  //   ) {
  //     setIsDisplayed(true);
  //   }
  // }, [filtersState[filtersKeys[0]]]);

  const handleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  //--- Dynamic Import
  const FilterItem = clientComponent["FilterItem"];

  typeFilters = filters[filterName]["values"].map((filter, i) => {
    if (filtersSearch) {
      if (filter.slug.includes(slugify(filtersSearch))) {
        return (
          <FilterItem
            key={filterName + filter.id}
            filter={filter}
            filtersState={filtersState}
            filterName={filterName}
            setFiltersState={setFiltersState}
            itemDiv={itemDiv}
            filters={filters}
            setSelectedInstitution={setSelectedInstitution}
            filtersKeys={filtersKeys}
          />
        );
      }
    } else {
      return (
        <FilterItem
          key={filterName + filter.id}
          filter={filter}
          filtersState={filtersState}
          filterName={filterName}
          setFiltersState={setFiltersState}
          itemDiv={itemDiv}
          filters={filters}
          setSelectedInstitution={setSelectedInstitution}
          filtersKeys={filtersKeys}
        />
      );
    }
  });

  const handleChange = (e) => {
    setFiltersSearch(e.target.value);
  };

  const emptySearchbar = () => {
    filterSearchRef.current.value = "";
    setFiltersSearch("");
  };

  return (
    <React.Fragment key={filterName}>
      {/* {index < 1 || filtersState[filtersKeys[0]]?.includes(filters[filterName]["slug"]) ? ( */}
      {/* {index < 1 ? (
        <> */}
      {/* {!filters[filterName]["isSubFilter"] && (
        <> */}
      {!filters[filterName]["isSubFilter"] && filters[filterName]["title"] && (
        <div className={`generic-filter ${isOpen ? "open" : ""}`}>
          <div onClick={() => handleOpen()} className="generic-filter__title">
            {filters[filterName]["title"]}
          </div>
          <div className="items__wrapper" style={{ display: "none" }}>
            {filters[filterName]["isSearchable"] && (
              <div className="subfilters-search__wrapper">
                <span className="iconReactLeafletsearch"></span>
                <input
                  className="subfilters-search"
                  type="text"
                  onChange={(e) => handleChange(e)}
                  placeholder={`${t("searchFrom")} ${
                    filters[filterName].title
                  }`}
                  ref={filterSearchRef}
                />
                {filtersSearch && (
                  <span
                    onClick={emptySearchbar}
                    className="icon iconReactLeafletx"
                  ></span>
                )}
              </div>
            )}{" "}
            <div className="items__wrapper-inner">
              <OverlayScrollbarsComponent
                className="overlay-scrollbar os-theme-dark"
                options={{
                  overflowBehavior: {
                    x: "hidden",
                    y: "scroll",
                  },
                }}
                // ref={scrollbarRef}
              >
                {typeFilters}
              </OverlayScrollbarsComponent>
            </div>
          </div>
        </div>
      )}
      {/* </>
      )} */}
      {/* </>
      ) : (
        <></>
      )} */}
    </React.Fragment>
  );
};
export default GenericFilter;
